import React from 'react';
import PropTypes from 'prop-types';
import { Col, ListGroup, Row } from 'reactstrap';
import { useIntl } from 'react-intl';

import SettingsEditButtons from '../../EditButtons';
import AdminSettingsItem from '../../Item/Item';
import TrialNotice from '../../../../TrialNotice';
import UpgradePlanButton from '../../../../UpgradePlanButton';

const SettingsImageEditor = ({
  settings,
  hiddenSettings,
  handleSettingChange,
  saving,
  handleSave,
  unsaved,
}) => {
  const intl = useIntl();

  const viewAllowedSettings = [
    'image_editor_presets_show_by_default',
    'image_editor_presets',
  ];

  return (
    <>
      <div className="settings-inner-content">
        <Row>
          <Col>
            <h3>
              {intl.formatMessage({ defaultMessage: 'Image Editor' })}
              <UpgradePlanButton feature="image-editor" />
            </h3>
          </Col>
        </Row>
        <TrialNotice feature="image-editor" className="pl-0" />
        <ListGroup flush className="switch-list workspace-settings-list">
          {Object.keys(settings)
            .filter(s => (viewAllowedSettings.includes(s)))
            .filter(s => (!hiddenSettings.includes(s)))
            .map(key => (
              <AdminSettingsItem
                key={key}
                settingKey={key}
                setting={settings[key]}
                handleSettingChange={handleSettingChange}
              />
            ))}
        </ListGroup>
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </>
  );
};

SettingsImageEditor.propTypes = {
  settings: PropTypes.object.isRequired,
  hiddenSettings: PropTypes.array.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
};

export default SettingsImageEditor;
